import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const P107GetDataList= async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.contractorService}p_contractor_order_pending_list`), body, authorization)
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


